enum AuthModalSteps {
  ACCOUNT,
  WALLET
}

export { AuthModalSteps };
